import { BaseMapper } from '@ps/utils';
import { SurveyLocationUploadResult } from '@ps/survey-utils';

import {
  FsaUploadResponseDto,
  LocationUploadResponseDto,
} from '../dtos/location-upload.dto';
import { FsaUploadMapper } from './fsa-upload.mapper';
import { ZipcodeUploadMapper } from './zipcode-upload.mapper';

const _isFsaUpload = (
  dto: LocationUploadResponseDto,
): dto is FsaUploadResponseDto => 'fsaFilePath' in dto;

export class LocationUploadMapper extends BaseMapper<
  LocationUploadResponseDto,
  SurveyLocationUploadResult
> {
  private readonly _zipcodeMapper = new ZipcodeUploadMapper();
  private readonly _fsaMapper = new FsaUploadMapper();

  public fromDto(dto: LocationUploadResponseDto): SurveyLocationUploadResult {
    return _isFsaUpload(dto)
      ? this._fsaMapper.fromDto(dto)
      : this._zipcodeMapper.fromDto(dto);
  }
}
